export const SELECTED_UNIT_OPERATIONS_LABEL = 'Selected unit operations';

export const INACCESSIBLE_STUDY_ERROR_TEXT =
  'This study is no longer accessible. Try refreshing the page if this is unexpected.';
